var timeToNextPlay, dayCutOff = 16;

var showNextPlayCountdown = function () {
    var d = new Date();
    var d3;

    if (d.getUTCHours() < dayCutOff) {
        var till10 = dayCutOff - d.getUTCHours();
        d3 = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours() + till10, 0, 0);
    } else {
        var till10 = d.getUTCHours() - dayCutOff
        d3 = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1, d.getHours() - till10, 0, 0);
    }
    timeToNextPlay = Math.abs(d3 - d);

    var timer1 = new IREP.Countdown({ totalTime: timeToNextPlay, updateTime: 1000 });
    timer1.start().progress(handleNextPlayProgress).done(handleNextPlayRanOut).fail(handleNextPlayStopped);
}

var handleNextPlayProgress = function (args) {
    var duration = timeToNextPlay - args.elapsed;
    var seconds = parseInt((duration / 1000) % 60)
    , minutes = parseInt((duration / (1000 * 60)) % 60)
    , hours = parseInt((duration / (1000 * 60 * 60)) % 24);

    hours = ((hours < 10) ? "0" + hours : hours).toString();
    minutes = ((minutes < 10) ? "0" + minutes : minutes).toString();
    seconds = ((seconds < 10) ? "0" + seconds : seconds).toString();
    updateClock(hours, minutes, seconds);
};

var updateClock = function (hours, minutes, seconds) {
    $("#nextPlayTimer, #launchTimer").find(".hours").find(".left").html(hours[0]);
    $("#nextPlayTimer, #launchTimer").find(".hours").find(".right").html(hours[1]);
    $("#nextPlayTimer, #launchTimer").find(".minutes").find(".left").html(minutes[0]);
    $("#nextPlayTimer, #launchTimer").find(".minutes").find(".right").html(minutes[1]);
    $("#nextPlayTimer, #launchTimer").find(".seconds").find(".left").html(seconds[0]);
    $("#nextPlayTimer, #launchTimer").find(".seconds").find(".right").html(seconds[1]);
}

var handleNextPlayRanOut = function (args) {
    window.location.reload();
};

var handleNextPlayStopped = function (args, customArgs) {
    window.location.reload();
};
var volume = 0;

IREP.futbol = (function () {
    var options, states, fsm, gameObjects = {}, middleScreenPoint, distanceScale = 1000, field = { width: 825, height: 181, horizontalScale: 1135 / 825, verticalScale: 249 / 181, centerYAdjustment: 32 }, defensiveColor;
    
    
    var init = function (initOptions) {
        volume = 0.0;
        
        $("body").css('background-repeat', 'no-repeat');
        $("body").css('background-color', 'black');
        $("body").css('overflow', 'hidden');

        if (volume == 0) {
            $("#sound").css({ "background-image": "url(" + IREP.options.appUrl + "/content/images/futbol/SpeakerIcon_white_off.png)" });
        }
           
        middleScreenPoint = { x: $(window).width() / 2, y: $(window).height() / 2 };
        options = initOptions;
        states = IREP.futbolStates.init();
        createGameObjects();

        fsm = IREP.futbol.fsm;

        fsm.init({
            states: states,
            defaultTransition: defaultTransition,
            initialState: "preGame",
            customTransitions: customTransitions,
            maxWrong: 2
        });

        $(window).resizeDebounce({
            onResizeEnd: recalculateGamePositions,
            runOnStart: false,
            timeoutDelay: 100
        });

        
        if (options.canPlay == "False") {
            showNextPlayCountdown();
        }

        $("#toggleHUD").on("click", function() {
            $("#hud").toggle();
            return false;
        });

        $("#startQuiz").one("click", startQuiz);
        $("#sound").on("click", toggleSound);
        fsm.next();
    };

    var recalculateGamePositions = function() {
        middleScreenPoint = { x: $(window).width() / 2, y: $(window).height() / 2 };
        var currentStateData = states[fsm.getCurrentState()];
        $.each(currentStateData.moves, function(name, transitionData) {
            var lastAnimation = transitionData[transitionData.length - 1];
            var lastCoordinate = lastAnimation.coordinates[lastAnimation.coordinates.length - 1];
            var object = gameObjects[name];
            var point = Coordinate(lastCoordinate.x, lastCoordinate.y).mapToPoint(name);
            $(object.selector).css({ top: point.y, left: point.x });
        });
    };

    var defaultTransition = function (stateData, skipQuestion) {
        
        $("#animationOverlay").show();
        $(".player", options.fieldElement)
            .removeClass("activePlayer")
            .off();
        $(".nextOption").remove();
        var timeline = new TimelineLite({ onComplete: defaultTransitionCompletion, onCompleteParams: [stateData, skipQuestion] });
        $.each(stateData.moves, function(name, transitionData) {
            var transition = AnimationTransition(transitionData);            
            var animationTimeline = transition.run(name, timeline);            
            timeline.insert(animationTimeline);
        });
        
        timeline.play();
        
        
    };

    var defaultTransitionCompletion = function (stateData, skipQuestion) {
        var sortedObjects = sortGameObjectsByYValue();
        $.each(sortedObjects, function(index, object) {
            $(object.data.selector).css({ zIndex: index });
        });

        var activePlayer = gameObjects[stateData.playerWithBall];
        if (activePlayer != null) {
            $(activePlayer.selector).addClass("activePlayer");
        }

        if (stateData.advanceOnCompletion === true) {
            handleNextOptions();
        }
        else if (skipQuestion !== true) {
            IREP.futbol.quiz.displayQuestion();
        }

        $("#animationOverlay").hide();
    };

    var customTransitions = {
        preGame: function(stateData) {
            $.each(stateData.moves, function(name, coordinate) {
                PlaceObjectTransition(coordinate).run(name);
            });
            fsm.next();
        },
        start: function(stateData) {
            defaultTransition(stateData, true);
        },
        zoomInOnGoal_DiveLeft: function(stateData) {
            zoomInOnGoal(stateData, "L");            
        },
        zoomInOnGoal_DiveRight: function(stateData) {
            zoomInOnGoal(stateData, "R");
        },
        red: function (stateData) {
            showResults(false);
        },
        winner: function(stateData) {
            showResults(true);
        },
        availablePlaysExceeded: function (playsRemaining) {
            
            $("#quizQuestion").hide();
            $("#passed").hide();
            $("#failed").hide();
            $("#questionProgress").hide();
            $("#availablePlaysRemaining").html(playsRemaining + " " + options.playsRemainingText).addClass("noMore").show();
            $("#remaining", "#availablePlaysExceeded").html(playsRemaining + " " + options.playsRemainingText).show();
            $("#availablePlaysExceeded").show();
            $("#gameOver").show();
            showHud();
        }
    };

    var zoomInOnGoal = function(stateData, direction) {
        $(options.fieldElement).hide();
        hideHud();
        $("body").css({ backgroundImage: "url(" + IREP.options.appUrl + "/content/images/futbol/goal_shot.jpg)" });
        var goalie = createGoalie(stateData, direction);
        var ball = createBall(stateData, direction);
        setTimeout(function() { defaultTransition(stateData, true); }, 250);

    };

    var showResults = function(passed) {
        IREP.futbol.quiz.postResults().done(function(data) {
            if (data.canPlayInfo != null && data.canPlayInfo.canPlay === true) {
                $("#quizQuestion").hide();
                $("#gameOver").show();
                $("#passed").toggle(passed);
                $("#failed").toggle(!passed);
                $("#availablePlaysRemaining").html(data.canPlayInfo.availablePlaysRemaining + " " + options.playsRemainingText).addClass((data.canPlayInfo.availablePlaysRemaining > 0) ? "more" : "noMore" ).show();
                $("#availablePlaysExceeded").html(data.canPlayInfo.availablePlaysRemaining + " " + options.playsRemainingText).show();
                $("#questionProgress").hide();
                showHud(); //$("#hud, #hudMain").show();
            } else {
                IREP.futbol.fsm.availablePlaysExceeded();
            }

            if (data.canPlayInfo != null && data.canPlayInfo.availablePlaysRemaining > 0) {
                $("#playAgain").show();
                $("#playButton").one("click", function () { window.location.reload(true); });
            } else {
               
                $("#playAgain").hide();
                $("#playButton").one("click", function () { return null; });
            }

        });
    };

    

    var hideHud = function () {
        $("#hudMain").hide();
        $("#ballLogo").hide();
        $(".footer").hide();
    };


    var showHud = function () {
        $("#hudMain").show();
        $("#ballLogo").show();
        $(".footer").show();
    };


    var createBall = function(stateData, direction) {
        var ball = new GoalViewBall();
        ball.addElement();
        gameObjects.goalViewBall = ball;
        var ballPosition = stateData.moves.goalViewBall[0].coordinates[0];
        PlaceObjectTransition(ballPosition).run(ball.name);
        return ball;
    };

    var createGoalie = function(stateData, direction) {
        var goalie = new Goalie();
        goalie.setAttributes({ color: defensiveColor, direction: direction });
        goalie.addElement();
        gameObjects.goalie = goalie;
        var goaliePosition = stateData.moves.goalie[0].coordinates[0];
        PlaceObjectTransition(goaliePosition).run(goalie.name);
        return goalie;
    };

    var handleNextOptions = function() {
        var stateData = states[fsm.getCurrentState()];
        if (stateData.nextStates.length == 1) {
            fsm.next();
        } else {
            if (stateData.nextStates != null) {
                $.each(stateData.nextStates, function(index, nextState) {
                    if (nextState.trigger != null) {
                        var triggerPlayer = gameObjects[nextState.trigger];
                        $(triggerPlayer.selector)
                            .addClass("nextOptionPlayer")
                            .one("click", function() {
                                fsm.next(nextState.trigger);
                            });

                        var nextOption = new NextOption(triggerPlayer);
                        nextOption.addElement();
                        $(nextOption.selector).css({ zIndex: -1 }).show();
                        nextOption.getTimeline();
                    }
                });
            }
        }
    };

    var startQuiz = function () {
        IREP.futbol.quiz.init({ progressText: options.progressText, totalTime: 15000 }).done(function(data) {
        $("#hudMain").hide();
            fsm.next();
            $("#howToPlay").hide();
            $("#quizQuestion").show();
        });
    };

    var toggleSound = function () {
        if (volume == 0) {
            $("#sound").css({ "background-image": "url(" + IREP.options.appUrl + "/content/images/futbol/SpeakerIcon_white.png)" });
            volume = 0;
            $.cookie("volume", 0);
        } else {
            $("#sound").css({ "background-image": "url(" + IREP.options.appUrl + "/content/images/futbol/SpeakerIcon_white_off.png)" });
            volume = 0;
            $.cookie("volume", 0);
        }
    };

    var createGameObjects = function() {
        var defense = ["defenseLeftMidfield", "defenseLeftForward", "defenseLeftCenterMidfield", "defenseLeftBack", "defenseLeftCenterBack", "defenseRightCenterMidfield", "defenseRightCenterBack", "defenseRightMidfield", "defenseRightBack", "defenseRightForward"];
        var offense = ["offenseRightBack", "offenseRightMidfield", "offenseRightCenterMidfield", "offenseRightForward", "offenseRightCenterBack", "offenseLeftForward", "offenseLeftCenterMidfield", "offenseLeftCenterBack", "offenseLeftMidfield", "offenseLeftBack"];

        var offenseIsLowerNumbers = Math.random() < 0.5;
        var offensiveColor = offenseIsLowerNumbers ? "Red" : "Yellow";
        defensiveColor = !offenseIsLowerNumbers ? "Red" : "Yellow";

        $.each(offense, function(index, playerName) {
            var offensivePlayer = new Player(playerName);

            offensivePlayer.setAttributes({ direction: "L", color: offensiveColor, number: getRandomPlayerNumber() });
            gameObjects[playerName] = offensivePlayer;
        });

        $.each(defense, function(index, playerName) {
            var defensivePlayer = new Player(playerName);

            defensivePlayer.setAttributes({ direction: "R", color: defensiveColor, number: getRandomPlayerNumber() });
            gameObjects[playerName] = defensivePlayer;
        });

        gameObjects["ball"] = new Ball();

        gameObjects["sidelineRef"] = new SidelineRef();

        var offenseGK = new GoalKeeper("offenseGoalKeeper")
        offenseGK.setAttributes({ color: offensiveColor, direction: "L" });
        gameObjects["offenseGoalKeeper"] = offenseGK;

        var defenseGK = new GoalKeeper("defenseGoalKeeper");
        defenseGK.setAttributes({color:defensiveColor, direction: "R"});
        gameObjects["defenseGoalKeeper"] = defenseGK;
        
        $.each(gameObjects, function(name, gameObject) {
            gameObject.addElement();
        });
    };

    var getRandomPlayerNumber = function() {
        var start = 1;
        var end = 2;
        return start + parseInt(Math.random() * (end - start + 1), 10);
    };

    var sortGameObjectsByYValue = function() {
        var sortByY = function(a, b) {
            var aPosition = $(a.data.selector).position();
            var bPosition = $(b.data.selector).position();
            return ((aPosition.top < bPosition.top) ? -1 : ((aPosition.top > bPosition.top) ? 1 : 0));
        };
        var objects = [];
        for (var name in gameObjects) {
            if (gameObjects.hasOwnProperty(name)) {
                objects.push({ id: name, data: gameObjects[name] });
            }
        }

        return objects.sort(sortByY);
    };

    var Coordinate = function(x, y) {
        if (!(this instanceof Coordinate)) {
            return new Coordinate(x, y);
        }

        this.x = x;
        this.y = y;
    };
    Coordinate.prototype.mapToPoint = function(elementId) {
        var x = this.x / distanceScale * field.width / 2;
        var y = this.y / distanceScale * field.height;

        y = y > 0 ? y * field.verticalScale : y;

        var howFarDownAmI = (this.y + distanceScale) / (distanceScale * 2);
        var howFarOverAmI = (this.x / distanceScale);
        var xOffset = (field.width * field.horizontalScale - field.width) / 2 * howFarDownAmI * howFarOverAmI;
        x += xOffset;

        var element = $("#" + elementId);
        var objectDimensions = { x: element.width(), y: element.height() };
        var objectOffset = { x: objectDimensions.x / 2, y: objectDimensions.y / 2 };
        var calculatedCoordinate = { x: x + middleScreenPoint.x - objectOffset.x, y: y + middleScreenPoint.y - field.centerYAdjustment - objectOffset.y };

        return calculatedCoordinate;
    };

    var Sprite = function(configOptions) {
        if (!(this instanceof Sprite)) {
            return new Sprite(configOptions);
        }
        if (configOptions != null) {
            this.totalWidth = configOptions.totalWidth;
            this.frameCount = configOptions.frameCount;
            this.delayBetweenFrames = configOptions.delayBetweenFrames;
            this.cssClass = configOptions.cssClass;
            this.name = configOptions.name;
            this.selector = "#" + this.name;
            this.skipFrameReset = configOptions.skipFrameReset;
        }
    };
    Sprite.prototype.getSpriteImage = function() {};
    Sprite.prototype.addElement = function() {
        var html = this.getHtml();
        $(options.fieldElement).append(html);
    };
    Sprite.prototype.getHtml = function() {
        var element = $("<div>").addClass("sprite " + this.cssClass).attr({ id: this.name, title: this.name }).css({ display: "none" });
        var innerElement = $("<div>").addClass("inner").attr({ id: "inner" + this.name }).css({ position: "absolute", background: "url(" + IREP.options.appUrl + "/content/images/futbol/" + this.getSpriteImage() + ")" });
        return element.append(innerElement);
    };
    Sprite.prototype.getTimeline = function() {
        var timeline = new TimelineMax({ repeat: -1, repeatDelay: 0 });
        var positionAdjustment = "-" + (this.totalWidth / this.frameCount * (this.frameCount - 1)) + "px 0px";
        var selector = this.selector.replace("#", "#inner");
        timeline.to(selector, this.delayBetweenFrames, { backgroundPosition: positionAdjustment, ease: SteppedEase.config(this.frameCount - 1) });
        if (this.skipFrameReset !== true) {
            timeline.set(selector, { backgroundPosition: "0 0" });
        }
        return timeline;
    };

    var Player = function(name) {
        Sprite.call(this, { totalWidth: 219, frameCount: 4, delayBetweenFrames: .4, cssClass: "player", name: name });
        this.team = name.indexOf("offense") === 0 ? "offense" : "defense";
    };
    Player.prototype = new Sprite();
    Player.prototype.constructor = Player;
    Player.prototype.setAttributes = function(attributes) {
        this.color = attributes.color;
        this.number = attributes.number;
        this.direction = attributes.direction;
    };
    Player.prototype.getSpriteImage = function() {
        return this.color + this.number + "-run-" + this.direction + "-sprite_small.png";
    };


    var SidelineRef = function () {
        Sprite.call(this, { totalWidth: 219, frameCount: 4, delayBetweenFrames: .4, cssClass: "ref", name: "sidelineRef" });        
    };
    SidelineRef.prototype = new Sprite();
    SidelineRef.prototype.constructor = SidelineRef;
    SidelineRef.prototype.getSpriteImage = function () {
        return "Ref_Sidestep-sprite_small.png";
    };

    var GoalViewBall = function () {
        Sprite.call(this, { totalWidth: 2070, frameCount: 23, delayBetweenFrames: .2, cssClass: "goalViewBall", name: "goalViewBall" });
    };
    GoalViewBall.prototype = new Sprite();
    GoalViewBall.prototype.constructor = GoalViewBall;
    GoalViewBall.prototype.getSpriteImage = function () {
        return "BALL_large.png";
    };
    GoalViewBall.prototype.addElement = function () {        
        var html = this.getHtml();
        $(options.goalElement).append(html);
    };

    var Ball = function() {
        Sprite.call(this, { totalWidth: 1035, frameCount: 23, delayBetweenFrames: .2, cssClass: "ball", name: "ball" });
    };
    Ball.prototype = new Sprite();
    Ball.prototype.constructor = Ball;
    Ball.prototype.getSpriteImage = function() {
        return "BALL_small_stroke_glow.png";
    };

    var NextOption = function(player) {
        Sprite.call(this, { totalWidth: 220, frameCount: 4, delayBetweenFrames: .6, cssClass: "nextOption", name: "option" + player.name });
        this.player = player;
    };
    NextOption.prototype = new Sprite();
    NextOption.prototype.constructor = Ball;
    NextOption.prototype.getSpriteImage = function() {
        return "options_circle_blink-sprite.png";
    };
    NextOption.prototype.addElement = function() {
        var html = this.getHtml();
        $(this.player.selector, options.fieldElement).append(html);
    };

    var GoalKeeper = function (name) {
        Sprite.call(this, { totalWidth: 219, frameCount: 4, delayBetweenFrames: .4, cssClass: "player", name: name });
        this.team = name.indexOf("offense") === 0 ? "offense" : "defense";
        
    };
    GoalKeeper.prototype = new Sprite();
    GoalKeeper.prototype.constructor = Player;
    GoalKeeper.prototype.setAttributes = function (attributes) {
        this.color = attributes.color;
        this.direction = attributes.direction;
    };
    GoalKeeper.prototype.getSpriteImage = function () {
        return this.color +  "Keeper-" + this.direction  + "-sprite_small.png";
    };

    var Goalie = function() {
        Sprite.call(this, { totalWidth: 6303, frameCount: 11, delayBetweenFrames: 1, cssClass: "goalie", name: "goalie", skipFrameReset: true });
    };
    Goalie.prototype = new Sprite();
    Goalie.prototype.constructor = Goalie;
    Goalie.prototype.getSpriteImage = function() {
        return this.color + "Goalie-miss-" + this.direction + "-sprite.png";
    };
    Goalie.prototype.setAttributes = function(attributes) {
        this.color = attributes.color;
        this.direction = attributes.direction;
    };
    Goalie.prototype.addElement = function() {
        var html = this.getHtml();
        $(options.goalElement).append(html);
    };

    var PlaceObjectTransition = function(coordinate) {
        if (!(this instanceof PlaceObjectTransition)) {
            return new PlaceObjectTransition(coordinate);
        }

        this.coordinate = Coordinate(coordinate.x, coordinate.y);
    };
    PlaceObjectTransition.prototype.run = function(elementId) {
        var point = this.coordinate.mapToPoint(elementId);
        $("#" + elementId).css({ top: point.y + "px", left: point.x + "px" }).show();        
    };

    var Animation = function(data, isLast) {
        if (!(this instanceof Animation)) {
            return new Animation(data, isLast);
        }

        this.coordinates = $.map(data.coordinates, function(coordinate) {
            return Coordinate(coordinate.x, coordinate.y);
        });
        this.delay = data.delay || .2;
        this.speed = data.speed || 2;
        this.isLast = isLast;
    };
    Animation.prototype.getTimeline = function(elementId, spriteAnimation) {
        var that = this;
        var object = gameObjects[elementId];
        var currentPosition = $("#" + elementId).position();

        var points = $.map(this.coordinates, function (coordinate) {
            var point = coordinate.mapToPoint(elementId);
            return { top: point.y, left: point.x };
        });

        var tweenOptions = {
            bezier: { values: points },
            ease: Power1.easeInOut,
            onComplete: function() {
                var repeatValue = (that.isLast ? 0 : -1);
                spriteAnimation.repeat(repeatValue);
            }
        };

        var isAlreadyInPosition = function (destinationPosition) {
            var isSameTop = parseInt(currentPosition.top, 10) === parseInt(destinationPosition.top, 10);
            var isSameLeft = parseInt(currentPosition.left, 10) === parseInt(destinationPosition.left, 10);
            return isSameTop && isSameLeft;
        }

        if (points.length === 1 && isAlreadyInPosition(points[0])) {
            tweenOptions = { onComplete: tweenOptions.onComplete };
            spriteAnimation.repeat(0);
        }

        return new TweenMax(object.selector, this.speed, tweenOptions);
    };

    var AnimationTransition = function (animations) {
        if (!(this instanceof AnimationTransition)) {
            return new AnimationTransition(animations);
        }
        this.animations = $.map(animations, function(animation, index) {
            var isLast = index == animations.length - 1;
            return Animation(animation, isLast);
        });

    };
    AnimationTransition.prototype.run = function (elementId) {        
        var object = gameObjects[elementId];
        var spriteAnimation = object.getTimeline();
        var timeline = new TimelineLite();

        $.each(this.animations, function(index, animation) {
            var moveAnimation = animation.getTimeline(elementId, spriteAnimation);
            timeline.append(moveAnimation);
        });
        return timeline;
    };

    return {
        init: init,
        handleNextOptions: handleNextOptions,
        getGameObject: function(name) {
            return gameObjects[name];
        }
};
})();

IREP.futbol.fsm = (function() {
    var defaultOptions = { states: {}, defaultTransition: function(stateData) {}, initialState: "initial", customTransitions: {}, maxWrong: 2 };
    var initialState, currentState, statesData, defaultTransition, customTransitions, statesDropdown, maxWrong;

    var init = function (initOptions) {
        var options = $.extend(defaultOptions, initOptions);
        statesData = options.states;
        defaultTransition = options.defaultTransition;
        customTransitions = options.customTransitions;
        maxWrong = options.maxWrong;
        initialState = options.initialState;
        statesDropdown = $("select#states");
        statesDropdown.empty();
        $.each(statesData, function(name, data) {
            statesDropdown.append($("<option>").val(name).html(name));
        });
        statesDropdown.on("change", function() {
            var newState = statesDropdown.val();
            transitionTo(newState);
        });
    };

    var transitionTo = function (state) {
        var stateData = statesData[state];
        currentState = state;

        if ($.isFunction(customTransitions[state])) {
            customTransitions[state].apply(this, [stateData]);
        } else {
            defaultTransition(stateData);
        }
        statesDropdown.val(currentState);
    };

    var next = function(trigger) {
        var nextState = null;

        if (currentState == null) {
            transitionTo(initialState);
        } else {
            var possibleNextStates = statesData[currentState].nextStates;
            if (possibleNextStates) {
                if (possibleNextStates.length == 1) {
                    nextState = possibleNextStates[0];
                } else if (possibleNextStates.length > 1) {
                    var matches = $.grep(possibleNextStates, function(possibleNextState) {
                        return possibleNextState.trigger === trigger;
                    });
                    nextState = matches.length >= 1 ? matches[0] : null;
                }
                if (nextState != null) {
                    transitionTo(nextState.state);
                }
            }
        }
    };

    var error = function (numberWrong) {
        var errorState = (numberWrong >= maxWrong) ? "red" : statesData[currentState].errorState;
        transitionTo(errorState);
    };

    var availablePlaysExceeded = function() {
        transitionTo("availablePlaysExceeded");
    };
        

    return {
        init: init,
        next: next,
        getCurrentState: function() {
            return currentState;
        },
        error: error,
        availablePlaysExceeded: availablePlaysExceeded,
    };
})();

IREP.futbol.quiz = (function() {
    var quizData, currentQuestionIndex, currentQuestion, progressText, numberCorrect, numberWrong, playId, timer, allowedTimePerQuestion, usedTime, results;

    var init = function (initOptions) {
        progressText = initOptions.progressText;
        allowedTimePerQuestion = initOptions.totalTime;
        timer = new IREP.Countdown({ totalTime: allowedTimePerQuestion, updateTime: 1000 });
        usedTime = 0;
        results = [];
        return IREP.callApi({ url: "/futbol/start" }).done(function (data) {
            if (data.canPlayInfo != null && data.canPlayInfo.canPlay === true) {
                quizData = data.quiz;
                currentQuestionIndex = 0;
                numberCorrect = 0;
                numberWrong = 0;
                playId = data.playId;
            } else {
                IREP.futbol.fsm.availablePlaysExceeded();
            }
        });

        
    };

    var displayQuestion = function() {
        currentQuestion = quizData.questions[currentQuestionIndex++];
        $("#questionProgress").html(progressText.replace("@@current@@", currentQuestionIndex).replace("@@total@@", quizData.questions.length));
        $("#questionText").html(currentQuestion.questionText);
        $("#answers").empty();
        $("#ref").css({ "background-image": "url(" + IREP.options.appUrl + "/content/images/futbol/ref_popup_default.jpg)" });
        var activePlayer = $(".activePlayer");
        if (activePlayer.length > 0) {
            var player = IREP.futbol.getGameObject(activePlayer[0].id);
            $("#currentPlayer").css({ "background-image": "url(" + IREP.options.appUrl + "/content/images/futbol/" + player.color + player.number + "_pop.jpg)" }).show();
        }
        $.each(currentQuestion.answers, function(index, answer) {
            var answerElement = $("<div>").addClass("answer").attr({ id: answer.answerId }).html(answer.answerText).one("click", handleAnswerSelection);
            $("#answers").append($("<div>").addClass("answerWrapper").append(answerElement));
        });

        $("#hudMain").show();
        $("#timerProgress").css({ width: 0 });     
        timer.start().progress(handleTimerProgress).done(handleTimerRanOut).fail(handleTimerStopped);
    };

    var handleTimerProgress = function(args) {
        var percentage = args.elapsed / allowedTimePerQuestion * 100;
        $("#timerProgress").css({ width: percentage + "%" });
    };

    var handleTimerRanOut = function(args) {
        handleAnswerSelection();
        usedTime += args.elapsed;
        postAnswer(0, args.elapsed);
    };

    var handleTimerStopped = function(args, customArgs) {
        usedTime += args.trueElapsed;
        postAnswer(customArgs.answerId, args.trueElapsed);
    };

    var handleAnswerSelection = function () {
        $(".answer").off();
        var selectedAnswerId = (this != null) ? this.id : 0;
        timer.stop({answerId: selectedAnswerId});
        var answer = $.grep(currentQuestion.answers, function (a) {
            return a.answerId == selectedAnswerId;
        });
        var isRight, answerId;
        if (answer != null && answer.length > 0) {
            isRight = answer[0].isCorrectAnswer;
            answerId = answer[0].answerId;
        } else {
            isRight = false;
            answerId = 0;
        }

        results.push({ questionId: currentQuestion.questionId, answerId: answerId, correct: isRight  });
        if (isRight) {
            numberCorrect += 1;
        } else {
            numberWrong += 1;
        }

        $("#correct").html(numberCorrect);

        if (isRight) {
            $("#hudMain").hide();
            IREP.futbol.handleNextOptions();
        } else {
            var color = (numberWrong <= 1 ? "yellow" : "red");
            $("#cards").removeClass("green").removeClass("yellow").removeClass("red").addClass(color);
            $("#ref").css({ "background-image": "url(" + IREP.options.appUrl + "/content/images/futbol/ref_popup_" + color + "card.jpg)" });
            
            setTimeout(function() {
                $("#hudMain").hide();
                IREP.futbol.fsm.error(numberWrong);
            }, 2000);
        }
    };

    var postAnswer = function(answerId, answerTime) {
        var data = {
            answerAudit: {
                auditUID: quizData.auditUID,
                answerID: answerId,
                answerTime: answerTime
            }
        };
        IREP.callApi({ url: "futbol/submit/answer", data: data, type: "POST" }).done(function(data) {
            if (data.canPlayInfo != null && data.canPlayInfo.canPlay === false) {
                IREP.futbol.fsm.availablePlaysExceeded();
            }
        });
    };

    var postResults = function() {
        var data = {
            quizData: {
                activityUID: quizData.activityUID,
                auditUID: quizData.auditUID,
                time: usedTime,
                results: results
            }, 
            playId: playId
        };
        return IREP.callApi({ url: "futbol/submit", data: data, type: "POST" });
    };

    return {
        init: init,
        displayQuestion: displayQuestion,
        postResults: postResults,
    };
})();

IREP.futbol.landing = (function () {

    

    var init = function (initOptions) { 

        $("#trainingBar").click(function () { 
            if ($("#arrow").hasClass("right")) {
                $("#arrow").removeClass("right").addClass("down");
                $(".sectionBody").slideDown(1000);
            }
            else {
                $("#arrow").removeClass("down").addClass("right");
                $(".sectionBody").slideUp(1000);
            }
                
        });
        

        //remove after emea launch
        var now = new Date();
        var d1 = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
        var d2 = new Date(2014, 5, 17, dayCutOff, 0, 0);        
        if (IREP.options.user.geoCode == 'EMEA' && d1 < d2) {
            showNextPlayCountdown();
        }
        
        if (initOptions.canPlay == "False") {
            showNextPlayCountdown();
        }

        $("#trainingBar").hover(function () {
            $(this).css({ "cursor": "pointer" });
        });
    };

    return {
        init: init
    };
})();